import React from "react";
import ProfessionalPatientsTable from "../shared/ProfessionalPatientsTable";

export default function KinesiologistPatients() {
  return (
    <ProfessionalPatientsTable
      queryKeyPrefix="kinesiologistPatients"
      endpointBase="kinesiologist-patients"
      backPath="/kinesiologists"
      titleKey="Kinesiologist.title_kinesiologist_patients"
      errorTitleKey="Kinesiologist.error_loading_patients"
      errorBackLabelKey="Kinesiologist.back_to_kinesiologists_button"
      headerBackLabelKey="Kinesiologist.button_back_to_kinesiologists"
    />
  );
}
